import { render, staticRenderFns } from "./MelosPlayerInterface.vue?vue&type=template&id=3ac99cf9&"
import script from "./MelosPlayerInterface.vue?vue&type=script&lang=ts&"
export * from "./MelosPlayerInterface.vue?vue&type=script&lang=ts&"
import style0 from "./MelosPlayerInterface.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports